<!-- FFLXCEL landing page -->
<div class="page-shell">
  <div class="global-bg" aria-hidden="true">
    <div class="grid-floor"></div>
    <div class="orb orb-a"></div>
    <div class="orb orb-b"></div>
  </div>
  <nav class="navbar" [class.scrolled]="scrolled" [class.menu-open]="menuOpen">
    <div class="container nav-inner">
      <button class="logo" (click)="scrollTo('hero')" aria-label="FFLXCEL home">
        <img src="assets/images/logo/Brian%20Logo_3.svg" alt="FFLXCEL" style="height: 58px; width: auto; vertical-align: middle;">
      </button>
      <div class="nav-links"><button (click)="scrollTo('features')">Features</button><button
          (click)="scrollTo('why-us')">Why Us</button><button (click)="scrollTo('pricing')">Pricing</button></div>
      <div class="nav-actions"><button class="btn btn-small" routerLink="/login">Login</button><button
          class="btn btn-small" (click)="scrollTo('pricing')">Free Trial</button></div>
      <button class="menu-toggle" (click)="toggleMenu()" [attr.aria-expanded]="menuOpen"
        aria-label="Toggle navigation"><span></span><span></span><span></span></button>
      <div class="mobile-menu" *ngIf="menuOpen"><button (click)="scrollTo('features')">Features</button><button
          (click)="scrollTo('why-us')">Why Us</button><button (click)="scrollTo('pricing')">Pricing</button><button
          class="btn" routerLink="/login">Login</button><button class="btn" (click)="scrollTo('pricing')">Start free
          trial</button></div>
    </div>
  </nav>

  <main>
    <section id="hero" class="hero section-dark">
      <div class="crosshair ch-a"></div>
      <div class="crosshair ch-b"></div>
      <div class="container hero-grid">
        <div class="hero-copy reveal visible">
          <div class="eyebrow">◆ &nbsp; Trusted by Licensed FFL Dealers</div>
          <h1>The All-in-One Platform<br>for <span>Modern FFL Dealers</span></h1>
          <p>Deep ATF 4473 automation, live RSR/Lipsey’s/Davidson’s feeds, built-in accounting (no QuickBooks), kiosk DL
            scanning, and offline-first sync — capabilities no other FFL software has.</p>
          <div class="hero-actions"><button class="btn" (click)="scrollTo('pricing')">Start Free Trial →</button><button
              class="btn" (click)="scrollTo('features')">Watch Demo</button></div>
          <div class="micro-points"><span>◆ ATF & NICS integrated</span><span>⚡ Offline-first PWA</span><span>⚡ Live
              distributor feeds</span></div>
        </div>
        <div class="hero-visual reveal visible">
          <div class="metric chip-a"><b>100%</b><span>Compliance Score</span></div>
          <div class="metric chip-b"><b>2M+</b><span>Transfers Processed</span></div>
          <div class="dashboard tilt">
            <div class="dash-top">
              <div class="mini-logo">FFL<b>X</b>CEL</div>
              <div class="dash-search">app.fflxcel.com/dashboard</div>
              <div class="avatar">PK</div>
            </div>
            <div class="dash-body">
              <aside><span class="active">⊞ Dashboard</span><span>▤ Form 4473</span><span>▣ Inventory</span><span>◉
                  Customers</span><span>▥ Reports</span><span>$ Accounting</span><span>⚙ Settings</span></aside>
              <div class="dash-content">
                <div class="dash-heading">
                  <div><small>GOOD MORNING</small>
                    <h3>Operations Overview</h3>
                  </div><button>+ New Transfer</button>
                </div>
                <div class="kpis">
                  <div><small>Transfers Today</small><strong>24</strong><em>+18%</em></div>
                  <div><small>Pending 4473s</small><strong>7</strong><em>Needs review</em></div>
                  <div><small>Inventory Value</small><strong>$284K</strong><em>1,842 items</em></div>
                </div>
                <div class="chart-card">
                  <div class="chart-head">
                    <div><small>TRANSFER VOLUME</small><b>Last 12 months</b></div><span>+24.8%</span>
                  </div>
                  <div class="chart"><i style="height:34%"></i><i style="height:48%"></i><i style="height:42%"></i><i
                      style="height:64%"></i><i style="height:56%"></i><i style="height:72%"></i><i
                      style="height:66%"></i><i style="height:82%"></i><i style="height:77%"></i><i class="hot"
                      style="height:92%"></i><i style="height:86%"></i><i class="dark" style="height:96%"></i></div>
                </div>
                <div class="activity"><b>Recent activity</b>
                  <div><span class="dot"></span>
                    <p><strong>4473 approved</strong><small>Glock 19 Gen5 · R. Flores</small></p><time>3m</time>
                  </div>
                  <div><span class="dot orange"></span>
                    <p><strong>Inventory received</strong><small>RSR shipment · 16 items</small></p><time>18m</time>
                  </div>
                  <div><span class="dot blue"></span>
                    <p><strong>DL scanned</strong><small>Buyer intake completed</small></p><time>31m</time>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="trust-strip">
      <div class="container">
        <p class="trust-title">BUILT TO MEET FEDERAL COMPLIANCE STANDARDS</p>
        <div class="trust-grid">
          <div *ngFor="let item of trust">
            <b>{{item[0]}}</b><span><strong>{{item[1]}}</strong><small>{{item[2]}}</small></span></div>
        </div>
      </div>
    </section>
    <!-- <section class="stats section-dark">
      <div class="container">
        <div class="stats-heading"><small>TRUSTED BY FFL DEALERS</small><i></i></div>
        <div class="stat-grid reveal">
          <div><b data-counter="dealers">0+</b><span>Active Dealers</span></div>
          <div><b data-counter="transactions">0M+</b><span>Transactions Processed</span></div>
          <div><b data-counter="uptime">0.0%</b><span>Uptime</span></div>
          <div><b data-counter="support">0/7</b><span>Support</span></div>
        </div>
      </div>
    </section> -->


    <section id="features" class="features section-dark">
      <div class="container">
        <div class="section-heading reveal"><small>CAPABILITIES NO COMPETITOR HAS</small>
          <h2>Built Different. On Purpose.</h2>
          <p>Every feature here exists because a real dealer told us they were doing it by hand.</p>
        </div>
        <div class="feature-layout reveal">
          <div class="feature-tabs"><button *ngFor="let f of features; let i=index" [class.active]="activeFeature===i"
              (click)="activeFeature=i"><b>{{f.icon}}</b><span><strong>{{f.label}}</strong></span></button></div>
          <div class="feature-detail">
            <div class="feature-copy"><small>{{features[activeFeature].tag}}</small>
              <h3>{{features[activeFeature].headline}}</h3>
              <p>{{features[activeFeature].description}}</p>
              <div class="preview-list">
                <div *ngFor="let bullet of features[activeFeature].bullets"><span>●</span>{{bullet}}</div>
              </div>
            </div>
            <div class="feature-preview">
              <div class="preview-title"><span><i></i><i></i><i></i></span><b>app.fflxcel.com —
                  {{features[activeFeature].label}}</b></div>
              <div class="preview-body product-ui">
                <ng-container *ngIf="activeFeature===0"><small class="ui-label">ACTIVE TRANSACTION — MULTI-HANDGUN
                    ALERT</small>
                  <div class="ui-alert"><b>⚠ &nbsp; Form 3310.4 Required</b><span>Customer purchasing 3 handguns in 5
                      days. ATF report auto-generated.</span></div>
                  <div class="ui-rows">
                    <div><span>Form 4473 Version</span><b>Oct 2023 Rev. (current)</b></div>
                    <div><span>Continuation Sheets</span><b class="red">Sheet 2 of 2 — auto-appended</b></div>
                    <div><span>NICS Transaction</span><b>#NTN2024-998812</b></div>
                    <div><span>FFL Verification</span><b>Licensed — expires 03/2027</b></div>
                  </div><small class="ui-sub">Reserved (Pending Customer Return)</small>
                  <div class="ui-item"><b>S&amp;W M&amp;P9 Shield EZ</b><span>R. Flores · 3 hrs</span></div>
                  <div class="ui-item"><b>Ruger LCP MAX</b><span>T. Green · 1 day</span></div>
                </ng-container>
                <ng-container *ngIf="activeFeature===1"><small class="ui-label">LIVE INVENTORY — ALL
                    DISTRIBUTORS</small>
                  <div class="ui-pills"><b>RSR</b><b>Lipsey’s</b><b>CSSI</b><b>Davidson’s</b></div>
                  <div class="ui-table">
                    <div class="head">
                      <span>Item</span><span>RSR</span><span>Lip.</span><span>Dav.</span><span>Best</span></div>
                    <div><b>Glock 19 Gen5</b><span>$429</span><span>$431</span><span>$435</span><em>RSR</em></div>
                    <div><b>M&amp;P Shield Plus</b><span>—</span><span>$349</span><span>$352</span><em
                        class="blue">LIP</em></div>
                    <div><b>Ruger LCP MAX</b><span>$249</span><span>$251</span><span>—</span><em>RSR</em></div>
                  </div>
                  <div class="ui-success"><b>Last synced:</b> 43 seconds ago · 4 distributors · 12,400 SKUs</div>
                </ng-container>
                <ng-container *ngIf="activeFeature===2"><small class="ui-label">PROFIT &amp; LOSS — YTD</small>
                  <div class="ui-finance">
                    <div><b>$286,110</b><small>Gross Revenue</small></div>
                    <div><b>$173,260</b><small>COGS (FIFO)</small></div>
                    <div><b>$72,390</b><small>Net Profit</small></div>
                  </div>
                  <div class="ui-rows">
                    <div><span>Accounts Receivable</span><b>$3,200</b></div>
                    <div><span>Accounts Payable (RSR)</span><b>$12,840</b></div>
                    <div><span>Last Vendor Credit</span><b class="red">−$220.00 (Invoice #4821)</b></div>
                    <div><span>Sales Tax Collected</span><b>$18,491 (TX 8.25%)</b></div>
                  </div>
                  <div class="ui-note">No QuickBooks subscription needed. Fully integrated.</div>
                </ng-container>
                <ng-container *ngIf="activeFeature===3"><small class="ui-label">DRIVER’S LICENSE SCAN —
                    AUTO-FILL</small>
                  <div class="ui-scan">
                    <div class="license-icon">▤</div><span><b>DL Scanned Successfully</b><small>Texas DL — 23 fields
                        auto-filled in 2.8s</small></span>
                  </div>
                  <div class="ui-rows">
                    <div><span>Full Name</span><b>THOMPSON, JAMES R.</b></div>
                    <div><span>Address</span><b>4412 Lone Star Blvd, Austin TX</b></div>
                    <div><span>DOB</span><b>09/14/1985 — Age: 39</b></div>
                    <div><span>ID Number</span><b>TX DL ••••••8821</b></div>
                    <div><span>Expiration</span><b>09/2029 — Valid</b></div>
                  </div><button class="ui-action">Start 4473 →</button>
                </ng-container>
                <ng-container *ngIf="activeFeature===4"><small class="ui-label">PURCHASE OPTIMIZER — REORDER</small>
                  <div class="ui-optimizer">
                    <div><small>SKU</small><b>GLK-G19-G5</b></div>
                    <div><small>Need</small><b>12 units</b></div>
                    <div><small>Best Source</small><b class="green">RSR · $429</b></div>
                    <div><small>Margin</small><b>34.1%</b></div>
                  </div>
                  <div class="ui-rows">
                    <div><span>RSR Group</span><b class="green">$429 · 84 available</b></div>
                    <div><span>Lipsey’s</span><b>$431 · 26 available</b></div>
                    <div><span>Davidson’s</span><b>$435 · 41 available</b></div>
                    <div><span>Suggested Retail</span><b class="red">$649.00</b></div>
                  </div><button class="ui-action">Create Purchase Order →</button>
                </ng-container>
                <ng-container *ngIf="activeFeature===5"><small class="ui-label">SYNC STATUS — LIVE</small>
                  <div class="ui-sync-grid">
                    <div><small>Connectivity</small><b class="amber">Offline</b></div>
                    <div><small>Local Cache</small><b class="green">Active</b></div>
                    <div><small>Queued Writes</small><b class="blue-text">3 pending</b></div>
                    <div><small>Last Sync</small><b>4 min ago</b></div>
                  </div><small class="ui-sub">Queued for sync on reconnect:</small>
                  <div class="ui-item"><b>4473 completed — Thompson, J.</b><span>2 min ago</span></div>
                  <div class="ui-item"><b>Inventory: +2 Glock 19 received</b><span>3 min ago</span></div>
                  <div class="ui-item"><b>POS sale — $716.49 processed</b><span>4 min ago</span></div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="why-us" class="why section-dark">
      <div class="container">
        <div class="section-heading reveal"><small>THE DIFFERENCE IS REAL</small>
          <h2>What Others Can’t Do</h2>
          <p>Most FFL software solves form storage. FFLXCEL runs your entire operation.</p>
        </div>
        <div class="why-layout reveal">
          <div class="compare">
            <div class="compare-head"><span>Feature</span><b>FFL<b class="x">X</b>CEL</b><span>Typical Software</span>
            </div>
            <div *ngFor="let row of comparisons" class="compare-row">
              <span>{{row[0]}}</span><strong>✓</strong><span>{{row[1] ? '✓' : '×'}}</span></div>
          </div>
          <div class="benefit-grid">
            <div><b>6 hrs</b><span>saved per week on paperwork</span><small>average across active dealers</small></div>
            <div><b>$100+</b><span>monthly savings vs QuickBooks</span><small>accounting suite is built-in</small></div>
            <div><b>2.8s</b><span>average buyer intake time</span><small>with DL barcode scan</small></div>
            <div><b>100%</b><span>offline capable</span><small>works in any wifi dead zone</small></div>
          </div>
        </div>
      </div>
    </section>

    <section class="how section-dark">
      <div class="container">
        <div class="section-heading reveal"><small>QUICK START</small>
          <h2>Up and Running in a Day</h2>
          <p>No IT department required. No training week. Just a faster way to run your dealership starting tomorrow.
          </p>
        </div>
        <div class="steps reveal">
          <div><b>01</b><i>＋</i>
            <h3>Create Your Account</h3>
            <p>Sign up in under 2 minutes. Add your FFL license and business details—we’ll verify and configure your
              license type.</p><small>Most dealers are live the same business day.</small>
          </div>
          <div><b>02</b><i>⚙</i>
            <h3>Import & Configure</h3>
            <p>Bring in bound book records, locations, staff roles, and NICS credentials. Our onboarding team handles
              everything.</p><small>Free data migration included with all plans.</small>
          </div>
          <div><b>03</b><i>↗</i>
            <h3>Operate & Grow</h3>
            <p>Process sales, complete 4473s, manage inventory, and keep your compliance score at 100% automatically.
            </p><small>Average dealer saves 6 hours every week.</small>
          </div>
        </div>
      </div>
    </section>
    <section class="testimonials section-dark">
      <div class="container">
        <div class="section-heading reveal"><small>DEALER STORIES</small>
          <h2>Real Dealers, Real Results</h2>
        </div>
        <div class="testimonial-grid reveal">
          <article *ngFor="let t of testimonials">
            <div class="stars">★★★★★</div>
            <blockquote>“{{t.quote}}”</blockquote>
            <div class="quote-stat"><b>{{t.stat}}</b><span>{{t.label}}</span></div>
            <div class="person">
              <div>{{t.name.charAt(0)}}</div><span><b>{{t.name}}</b><small>{{t.title}}</small></span>
            </div>
          </article>
        </div>
      </div>
    </section>
    <section id="pricing" class="pricing section-dark">
      <div class="container">
        <div class="section-heading reveal"><small>PRICING</small>
          <h2>Two Plans. <span>All The Features.</span></h2>
        </div>
        <div class="pricing-grid reveal">
          <article *ngFor="let p of plans" [class.popular]="p.popular">
            <div class="popular-tag" *ngIf="p.popular">MOST POPULAR</div>
            <h3>{{p.name}}</h3>
            <p>{{p.desc}}</p>
            <div class="price"><b>{{p.price}}</b><span>{{p.suffix}}</span></div>
            <ul>
              <li *ngFor="let item of p.features"><span>✓</span>{{item}}</li>
            </ul><button class="btn" (click)="selectPlan(p)">{{p.name==='Enterprise' ? 'Contact Sales' : 'Start Free Trial'}}</button>
          </article>
        </div>
      </div>
    </section>
    <section class="final-cta">
      <div class="cta-glow"></div>
      <div class="container reveal">
        <h2>Join Hundreds of Dealers<br><span style="color: white">Using FFL<span style="color: red">X</span>CEL</span></h2>
        <p>Automate compliance. Increase sales. Scale your business.</p>
        <div class="hero-actions center"><button class="btn" routerLink="/landing-page-sign-up" >Start Your Free Trial
            Today</button></div><small>No credit card required · Full access for 14 days</small>
      </div>
    </section>
  </main>
  <footer>
    <div class="container figma-footer">
      <div class="logo static"><img src="assets/images/logo/Brian%20Logo_3.svg" alt="FFLXCEL" style="height: 58px; width: auto; vertical-align: middle;"></div>
      <p>© 2026 FFLXCEL. All rights reserved. Not affiliated with the ATF.</p>
      <div><a>Privacy</a><a>Terms</a><a>Contact</a></div>
    </div>
  </footer>
</div>